// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dropdown-user[data-v-97c64364]  .dropdown-menu.dropdown-menu-right.show{margin-top:0}", ""]);
// Exports
module.exports = exports;
